export const statisticsQueryKeys = {
	all: (date: string = undefined) => ['statistics', 'date', date] as const,
	byResidentId: (residentId: string, date: string = undefined) =>
		[...statisticsQueryKeys.all(date), 'id', residentId] as const
};
